import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Thin wrapper around react-query for GET endpoints; cache is scoped to the active customer. */
export const useApi = (url, params = {}, options = {}) => {
  const { activeCustomerId, user } = useAuth();
  return useQuery({
    queryKey: [url, params, activeCustomerId, user?.id],
    queryFn: async () => (await api.get(url, { params })).data,
    enabled: !!user && (options.enabled ?? true),
    staleTime: options.staleTime ?? 60_000,
    refetchInterval: options.refetchInterval,
    placeholderData: options.keepPrevious ? (prev) => prev : undefined,
    retry: 1,
  });
};

export const useInvalidate = () => {
  const qc = useQueryClient();
  return (prefix) => qc.invalidateQueries({ predicate: (q) => (prefix ? String(q.queryKey[0]).startsWith(prefix) : true) });
};
